// extracted by mini-css-extract-plugin
export var carrierTab = "_63-0";
export var carrierTabActive = "_63-1 _63-0";
export var carrierTabInactive = "_63-2 _63-0";
export var carrierTabLabel = "_63-3";
export var carrierTabLabelActive = "_63-4 _63-3";
export var carrierTabLabelInactive = "_63-5 _63-3";
export var carrierTabPercentage = "_63-6";
export var carrierTabPercentageActive = "_63-7 _63-6";
export var carrierTabPercentageInactive = "_63-8 _63-6";
export var carrierTabWinnable = "_63-9";
export var carrierTabWinnableActive = "_63-a _63-9";
export var carrierTabWinnableInactive = "_63-b _63-9";
export var comparisonContainer = "_63-d";
export var missingRateButton = "_63-n";
export var missingRateButtonActive = "_63-o _63-n";
export var missingRateButtonInactive = "_63-p _63-n";
export var missingRateButtonLabel = "_63-q";
export var missingRateButtonLabelActive = "_63-r _63-q";
export var missingRateButtonLabelInactive = "_63-s _63-q";
export var sidebar = "_63-c";
export var strategyButton = "_63-e";
export var strategyButtonActive = "_63-f _63-e";
export var strategyButtonDescription = "_63-k";
export var strategyButtonDescriptionActive = "_63-l _63-k";
export var strategyButtonDescriptionInactive = "_63-m _63-k";
export var strategyButtonInactive = "_63-g _63-e";
export var strategyButtonLabel = "_63-h";
export var strategyButtonLabelActive = "_63-i _63-h";
export var strategyButtonLabelInactive = "_63-j _63-h";
export var unitToggleButton = "_63-t";
export var unitToggleButtonActive = "_63-u _63-t";
export var unitToggleButtonInactive = "_63-v _63-t";
export var unitToggleButtonLabel = "_63-w";
export var unitToggleButtonLabelActive = "_63-x _63-w";
export var unitToggleButtonLabelInactive = "_63-y _63-w";